/*
 * This file is part of glowingblue/orell-bookshelf.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import Page, { type IPageAttrs } from 'flarum/common/components/Page';
import extractText from 'flarum/common/utils/extractText';
import type Mithril from 'mithril';
import * as terms from '@fof-terms';
const UpdateAlert = terms.components.UpdateAlert;
import BookshelvesHero from './BookshelvesHero';
import BookshelvesList from './BookshelvesList';
import BookshelvesListState from '../states/BookshelvesListState';
import redrawWhenSettled from '../utils/redrawWhenSettled';

export interface BookshelvesPageAttrs extends IPageAttrs {
	isOwn?: boolean;
}

export default class BookshelvesPage<CustomAttrs extends BookshelvesPageAttrs = BookshelvesPageAttrs> extends Page<
	CustomAttrs,
	BookshelvesListState
> {
	oninit(vnode: Mithril.Vnode<CustomAttrs, this>) {
		super.oninit(vnode);

		// @ts-expect-error -- deliberate single-argument push, a title would land on the stack.
		app.history.push('all_book_collections');
		this.bodyClass = 'App--bookshelves';
		app.setTitle(extractText(app.translator.trans('glowingblue-orell-bookshelf.forum.bookshelves.title')));

		const { isOwn } = this.attrs;

		this.state = new BookshelvesListState({ showAll: !isOwn, sort: m.route.param('sort') });

		this.state.refresh();
	}

	view(): Mithril.Children {
		return (
			<div className="BookshelvesPage">
				{UpdateAlert && <UpdateAlert />}
				<BookshelvesHero isOwn={this.attrs.isOwn} onCreated={() => redrawWhenSettled(this.state.refresh())} />
				<div className="container">
					<BookshelvesList state={this.state} />
				</div>
			</div>
		);
	}
}
